import { render, staticRenderFns } from "./TagsListDisplay.vue?vue&type=template&id=6119f4cc&scoped=true"
import script from "./TagsListDisplay.vue?vue&type=script&lang=js"
export * from "./TagsListDisplay.vue?vue&type=script&lang=js"
import style0 from "./TagsListDisplay.vue?vue&type=style&index=0&id=6119f4cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6119f4cc",
  null
  
)

export default component.exports